import React from 'react';
import './common.scss';

const IDVButton=({ isButtonDisabled, onBtnClick, title, id, toggleStyle, track, ariaLabel })=>{
  return(
    <div className="idv-btn-wrapper">
      <button className={`idv-btn ${toggleStyle?'idv-white':'button-override-color'} ${isButtonDisabled?'idv-btn-disabled':''}`}
        id={id}
        data-track={track}
        disabled={isButtonDisabled}
        onClick={onBtnClick}
        aria-label={ariaLabel}><span>{title}</span></button>
    </div>
  );
};

export default IDVButton;
